module.exports = __webpack_public_path__ + "static/media/PM115.bc6e4873.png";